import { styled } from '@mui/material/styles';

export const StyledWrapper = styled('div')`
  width: 100%;
`;